import Modal from '../../Basic/Modal/Modal.mjs';
import styled, { keyframes } from 'styled-components';

const scaleFadeAnimation = keyframes `
  0% {
    transform: scale(0);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
`;
const StyledModalContainer = styled(Modal) `
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 343px;
  padding: 3.5rem 1.5rem 2.5rem;
  gap: 1.5rem;

  @media screen and (min-width: ${props => props.theme.breakpoints.sm}) {
    max-width: 524px;
    padding: 3.5rem 1.5rem;
  }
`;
const StyledIconContainer = styled.div `
  animation: ${scaleFadeAnimation};
  animation-duration: ${props => props.theme.animation.duration.quick2};
  animation-timing-function: ${props => props.theme.animation.easing.expressive.entrance};

  svg {
    width: 100px;
    height: 100px;

    @media screen and (min-width: ${props => props.theme.breakpoints.sm}) {
      width: 150px;
      height: 150px;
    }
  }
`;

export { StyledIconContainer, StyledModalContainer };
//# sourceMappingURL=StatusMessageModal.styles.mjs.map
